import {IJob, JOB_STATUS} from "../../../types/models/Job.ts";
import {Box, Skeleton, Stack, Typography} from "@mui/material";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner.tsx";
import {CardSlider} from "../../CutJobPage";
import {Expandable} from "@laser-project/kyui";
import {TransformAnimation} from "../../../components/Animations/TransformAnimation/TransformAnimation.tsx";
import React from "react";
import {FeatureSlider} from "../../CutJobPage";
import {IFeature} from "../../../types/models/Feature.ts";
import {IAction, IActionSpec} from "../../../types/models/Action.ts";
import {GaugesSlider} from "../../CutJobPage";
import {IGaugeDedupe} from "../../CutJobPage";

export interface StepByStepInterface {
    filteredFeatures: (IFeature[] | null),
    job: IJob,
    renderPreviewStepTarget: number,
    flattenedActionList: (IAction[] | IActionSpec[] | undefined)
    actionId: string,
    isSubmitting: boolean,
    handleUserInputSubmit: (answeredInput: object) => Promise<void>
}

export function StepByStepSwitcher(props: Readonly<StepByStepInterface>) {

    if (JOB_STATUS.UNASSIGNED === props.job?.status) {
        return (
            <Stack spacing={3}>
                <LoadingSpinner message={"Model is being analyzed"}/>
                <Typography variant={"h1"} gutterBottom>{props.job?.title ?? <Skeleton/>}</Typography>
                <FeatureSlider filteredFeatures={props.filteredFeatures}/>
            </Stack>
        )
    }
    if (props.renderPreviewStepTarget === 7) {
        return (
            <Stack spacing={3}>
                <Typography variant={"h1"} gutterBottom>{props.job?.title ?? <Skeleton/>}</Typography>
                <CardSlider
                    handleUserInputSubmit={props.handleUserInputSubmit}
                    elements={props.flattenedActionList}
                    activeElementId={props.actionId}
                    currentSubmitting={props.isSubmitting}
                />
                <Expandable title={"Gauges"}>
                    <GaugesSlider filteredFeatures={props.filteredFeatures}/>
                </Expandable>
                <Expandable title={"Features"}>
                    <FeatureSlider filteredFeatures={props.filteredFeatures}/>
                </Expandable>
            </Stack>
        )
    }

    return (
        <Stack spacing={3}>
            <Typography variant={"h1"} gutterBottom>{props.job?.title ?? <Skeleton/>}</Typography>
            <Box sx={{paddingTop: 1, paddingBottom: 1}}>
                <TransformAnimation
                    cards={props.job?.features?.map(feature => {
                        return {
                            primary: feature,
                            secondary: feature.dependencies as IGaugeDedupe[]
                        }
                    }) ?? []}
                    animationTarget={props.renderPreviewStepTarget}
                    onComplete={() => {
                        console.log("calling set done")
                    }}
                />
            </Box>
        </Stack>
    )

}